<template>
  <div class="chatWidget">
    <template v-if="currentUser && currentUser.id > 0">
      <div class="add_user">
        <AddCustomerDialog :dialog.sync="localAddCustomerDialog" @add="handleCustomerAdded" @update:dialog="$emit('update:add-customer-dialog', $event)" :saloon-ctrl="true" :disabled="false"></AddCustomerDialog>
      </div>
      <div v-if="messages" class="dashboardMessager">
        <Dashboard :positionOut="true" />
        <div class="closeBtn">
          <v-btn text @click="toggleMsgs">
            <v-icon class="mr-2">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="home_page_outer" v-if="showHome">
        <div class="home_page_inner">
          <Homepage />
        </div>
        <div class="closeBtn">
          <v-btn text @click="showWidget">
            <v-icon class="mr-2">mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
      <div class="reactFrame">
        <iframe :src="getFrontUrl" height="100%" width="100%" ref="reactFrame" allow="camera *; microphone *; autoplay; fullscreen"> </iframe>
      </div>
    </template>
    <template v-if="!currentUser">
      <p>please wait</p>
    </template>
  </div>
</template>
<script>
import AddCustomerDialog from "@/components/homepage/AddCustomerDialog";
import Homepage from "./Homepage.vue";
import Dashboard from "./Dashboard.vue";
import currentUserService from "@/services/currentUser.service";
import billService from "@/services/bills/bills.service.js";
export default {
  name: "Reviews",
  components: {
    AddCustomerDialog,
    Homepage,
    Dashboard,
  },
  mixins: [],
  data: function () {
    return {
      localAddCustomerDialog: false,
      showHome: false,
      messages: false,
      currentUser: null,
      currentLicense: null,
    };
  },
  props: {},
  inject: ["updateParent"],
  methods: {
    showWidget() {
      this.showHome = !this.showHome;
    },
    notifyParent() {
      this.updateParent({ showScanner: true });
    },
    toggleMsgs() {
      this.messages = !this.messages;
    },
    async handleCustomerAdded(data) {
      console.log("customer added");
      this.sendMessage({
        type: "FROM_VUE",
        payload: {
          type: "add_customer",
          status: true,
        },
      });
    },
    sendMessage(payload) {
      const iframe = this.$refs.reactFrame;
      iframe.contentWindow.postMessage(
        payload,
        "https://d3qscn84zyqs8s.cloudfront.net" // React app domain
      );
    },
    async handleMessage(event) {
      if (event.origin !== "https://d3qscn84zyqs8s.cloudfront.net") return;
      console.log(event.data, "i am from server ");
      if (event.data && event.data.operation == "add") {
        this.localAddCustomerDialog = false;
        this.localAddCustomerDialog = true;
      }
      if (event.data && event.data.operation == "whatsapp") {
        this.messages = true;
      }
      if (event.data && event.data.id == "team") {
        this.$router.push("/analytics/operatorsBalance").catch(() => {});
      }

      if (event.data && event.data.id == "service") {
        this.$router.push("/analytics/serviceTypesBalance").catch(() => {});
      }
      if (event.data && event.data.id == "news") {
        this.$router.push("/marketing/newsList").catch(() => {});
      }
      if (event.data && event.data.operation == "edit" && event.data && event.data.id > 0) {
        this.$router.push({
          name: "CustomersRegistryEditForm",
          params: {
            id: event.data.id,
          },
          query: {
            pathToGoBack: this.$router.resolve({ name: "DashboardNew" }).href,
            pathName: "DashboardNew",
          },
        });
      }
      if (event.data && event.data.operation == "delete" && event.data && event.data.item && event.data.item.id > 0) {
        this.$delegates.snackbar("attendere prego durante l'eliminazione");
        const ctrl = await billService.getBillFromCustomer(event.data.item.customer.id);
        if (!ctrl)
          billService
            .deleteBill({ id: event.data.item.id })
            .then(async (results) => {
              this.$delegates.snackbar("Eliminato con successo");
            })
            .catch(async (err) => {
              if (err == "event group still present") {
                this.$delegates.snackbar("Eliminare l'appuntamento in agenda prima di rimuovere il cliente");
              }
            });
        else {
          this.$delegates.snackbar("C'è un conto aperto nel bar");
        }
        //this.$router.push("/registries/customers/" + event.data.id + "/edit?tabName=registry").catch(() => {});
      }
      if (event.data && event.data.id == "badge_login") {
        this.notifyParent();
      }
      if (event.data && event.data.operation == "view") {
        //this.showWidget();
        this.$router.push("/").catch(() => {});
      }
    },
  },
  computed: {
    getFrontUrl() {
      return "https://d3qscn84zyqs8s.cloudfront.net/admin/reviews?iType=" + this.currentLicense?.schemaName;
    },
  },
  watch: {},
  mounted: async function () {
    window.addEventListener("message", this.handleMessage);
    const currentUserRes = await currentUserService.getUser();
    if (currentUserRes && currentUserRes.licenses && currentUserRes.licenses.length > 0) {
      this.currentUser = currentUserRes;
      this.currentLicense = currentUserRes.licenses[0];
      //console.log(this.currentLicense);
    } else {
      //alert("you are not allowed to see this page");
    }
    //console.log(currentUserRes, "currentUserRes");
  },
};
</script>
<style scoped>
.add_user {
  display: none;
}
.chatWidget {
  width: 100%;
  background: #efefef;
  margin: 0;
  height: 100vh;
  overflow: hidden;
}
iframe {
  border: 0;
  height: 100%;
  width: 100%;
}
.home_page_outer {
  position: fixed;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9999;
  padding: 20px;
  top: 0;
  width: 100%;
  left: 0;
  width: calc;
  height: 100vh;
  overflow: auto;
}

.home_page_outer .home_page_inner {
  background-color: #fff;
  border-radius: 10px;
}

.closeBtn {
  position: absolute;
  right: 10px;
  background: #7c9fe3;
  border-radius: 10px;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 39px;
  top: 10px;
  color: #fff;
}
.closeBtn button {
  min-width: 0 !important;
  padding: 0 !important;
  margin: 0 !important;
  color: #fff !important;
}
.closeBtn button i {
  margin: 0 !important;
  padding: 0 !important;
}
.dashboardMessager {
  position: absolute;
  z-index: 1;
  min-height: 100vh;
  background: #fcfaff;
  height: 100%;
  width: 100%;
  overflow: auto;
}
</style>
